module.exports = __webpack_public_path__ + "img/Filter.9c7000da.svg";